import { Link } from 'react-router-dom';
import { Compass } from 'lucide-react';

export function NotFoundPage() {
  return (
    <div className="grid min-h-dvh place-items-center bg-steel-100 p-6">
      <div className="w-full max-w-sm rounded-xl border border-steel-200 bg-white p-8 text-center">
        <Compass aria-hidden className="mx-auto size-10 text-steel-300" />
        <h1 className="mt-4 text-lg font-bold text-steel-900">Page not found</h1>
        <p className="mt-2 text-sm text-steel-600">
          That link does not lead anywhere in ODR. It may have been moved, or the record may
          have been removed.
        </p>
        <Link
          to="/"
          className="mt-6 inline-block rounded-lg bg-steel-800 px-5 py-3 text-sm font-semibold text-white hover:bg-steel-700"
        >
          Back to my work
        </Link>
      </div>
    </div>
  );
}
